import React from 'react'
import { Loader } from 'goustouicomponents/dist/Loader'
import css from './ContentLoader.module.css'

const ContentLoader = () => <div className={css.wrapper}><Loader color="Bluecheese" /></div>

export { ContentLoader }
